export default Object.freeze({
  LEVEL_IDX: 'LEVEL',
  CATEGORY: 'CATEGORY',
});
